import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { TipoRespaldoSubcategoriaDetalle } from '../../_models/tipo-respaldo-subcategoria-detalle';
import { TipoRespaldoSubcategoriaDetalleService } from '../../_services/tipo-respaldo-subcategoria-detalle.service';

@Component( {
  selector: 'app-tipo-respaldo-detalle-subcategoria',
  templateUrl: 'tipo-respaldo-detalle-subcategoria.component.html'
} )

export class TipoRespaldoDetalleSubcategoriaComponent implements OnInit {

  carInformacionInicial = true;
  lisSubcategoriaDetalle: TipoRespaldoSubcategoriaDetalle[] = [];
  carTabla = true;
  columnas: any[];
  @ViewChild('dt') tabla: Table;

  constructor( private serTipoRespaldoCategoria: TipoRespaldoSubcategoriaDetalleService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private router: Router,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serTipoRespaldoCategoria.listadoPorIdSubcategoria( params[ 'id' ] ).subscribe( subcategoriaDetalle => {
          this.lisSubcategoriaDetalle = subcategoriaDetalle;
          this.carServiciosIniciales();
        } );
      }
    } );

  }

  carServiciosIniciales() {

    this.columnas = [
      { field: 'codigoTipoRespaldoSubCategoria', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_CODSUBCAT' ), sort: true },
      { field: 'tipoRespaldoSubCategoria', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_NOMSUBCAT' ), sort: true },
      { field: 'nombreClaseRespaldo', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_CLASE' ), sort: true },
      { field: 'nombreSubClaseRespaldo', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_SUBCLASE' ), sort: true },
      { field: 'valorSMMLV', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_VALORSMMLV' ), sort: true },
      { field: 'valorPorcentaje', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_VALORPORCENTAJE' ), sort: true },
    ];

    this.carTabla = false;
    this.carInformacionInicial = false;
  }


  regresar( dirty: boolean ) {
    this.router.navigate( [ 'apl/tipo-respaldo/' ] );
  }


}
